module.exports = __webpack_public_path__ + "static/media/FP.50f78be8.jpg";